import React, { useEffect, useState, useRef } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { API_URL } from "../../../environment";

interface Message {
  id: string | number;
  status: "send" | "received";
  mensagem: string;
  timestamp: string;
  type: string;
}

interface MiniChatProps {
  phone: string;
  name: string;
  onClose: () => void;
}

const MiniChat: React.FC<MiniChatProps> = ({ phone, name, onClose }) => {
  const [messages, setMessages] = useState<Message[]>([]);
  const [newMessage, setNewMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const scrollRef = useRef<Scrollbars>(null);

  const fetchMessages = async () => {
    const id_cliente = localStorage.getItem("id_cliente");
    const instanceName = localStorage.getItem("instanceName");

    if (!id_cliente || !phone) return;

    // Criando os parametros de busca de forma segura
    const queryParams = new URLSearchParams({
      id_cliente: id_cliente,
      fone: phone,
      instanceName: instanceName || ""
    });

    try {
      // Fazendo o fetch com a URL formatada corretamente
      const res = await fetch(`${API_URL}/messages_by_phone?${queryParams.toString()}`);
      
      if (res.ok) {
        const data = await res.json();
        if (Array.isArray(data)) {
          setMessages(data);
        }
      }
    } catch (err) { 
      console.error("Erro ao buscar mensagens no MiniChat:", err); 
    } finally { 
      setLoading(false); 
    }
  };

  useEffect(() => {
    fetchMessages();
    const interval = setInterval(fetchMessages, 10000);
    return () => clearInterval(interval);
  }, [phone]);

  useEffect(() => {
    scrollRef.current?.scrollToBottom();
  }, [messages]);

  const handleSend = async () => {
    if (!newMessage.trim()) return;
    const instanceName = localStorage.getItem("instanceName");
    const id_cliente = localStorage.getItem("id_cliente");
    
    // Update otimista
    const tempMsg: Message = { id: Date.now(), status: "send", mensagem: newMessage, timestamp: new Date().toISOString(), type: "conversation" };
    setMessages(prev => [...prev, tempMsg]);
    setNewMessage("");

    try {
      await fetch(`${API_URL}/enviarmensagem`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ instanceName, fone: phone, text: newMessage, id_cliente })
      });
    } catch (e) { alert("Erro ao enviar"); }
  };

  return (
    <div className="mini-chat-container d-flex flex-column" style={{ height: "500px" }}>
      <div className="chat-header p-2 border-bottom d-flex justify-content-between align-items-center bg-light">
        <strong>{name} ({phone})</strong>
        <button className="btn-close" onClick={onClose}></button>
      </div>
      
      <div className="chat-body flex-grow-1 p-2" style={{ background: "#e5ddd5" }}>
        <Scrollbars ref={scrollRef}>
          {loading ? <p className="text-center mt-5">Carregando...</p> : 
            messages.map(m => (
              <div key={m.id} className={`d-flex mb-2 ${m.status === "send" ? "justify-content-end" : "justify-content-start"}`}>
                <div className={`p-2 rounded shadow-sm`} style={{ 
                    maxWidth: "80%", 
                    background: m.status === "send" ? "#dcf8c6" : "#fff",
                    fontSize: "13px"
                }}>
                  {m.mensagem}
                  <div className="text-muted text-end" style={{ fontSize: "9px" }}>
                    {new Date(m.timestamp).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}
                  </div>
                </div>
              </div>
            ))
          }
        </Scrollbars>
      </div>

      <div className="chat-footer p-2 border-top bg-white">
        <div className="input-group">
          <input 
            type="text" 
            className="form-control" 
            value={newMessage} 
            onChange={e => setNewMessage(e.target.value)}
            onKeyPress={e => e.key === "Enter" && handleSend()}
            placeholder="Digite sua mensagem..."
          />
          <button className="btn btn-primary" onClick={handleSend}><i className="ti ti-send" /></button>
        </div>
      </div>
    </div>
  );
};
export default MiniChat;